import { render } from "./StepOne.vue?vue&type=template&id=e755af12"
import script from "./StepOne.vue?vue&type=script&lang=js"
export * from "./StepOne.vue?vue&type=script&lang=js"

import exportComponent from "/home/arturo/Documentos/interfase/proyecto/id-antel/bio-web-client/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__